import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import Addmore from '../../components/Addmore';
import IseekCreateform from './IseekCreateform';
import Titleinput from './Titleinput';
import Pagination from '../../helpers/Pagination';
const $= window.$;


class IseekView extends Component {
    constructor(props) {
        super(props);
        //alert(JSON.stringify(this.props.feedbacks));
        this.state={

             pageOfItems:[],
            mailsents:'',
            poll_title : [],
            poll_answers : [],
            snap_poll_title:'',
            pollQuestions:[],
            feedbacks:[],
            show : 'block',
            hide : 'none',
            length : '',

        };
        this.fnGetSaveAsPage = this.fnGetSaveAsPage.bind(this);
        this.fnGetmails = this.fnGetmails.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.titleChange = this.titleChange.bind(this);
        this.getForm = this.getForm.bind(this);
    }


    componentWillReceiveProps(nextProps) {

         if(nextProps.feedbacks!=undefined){
            //alert(JSON.stringify(nextProps.feedbacksResults));
            this.setState({
                show : 'block',
                hide : 'none',
                feedbacks: nextProps.feedbacks,
                pageOfItems:nextProps.feedbacks,
            })

            //this.forceUpdate();
          //  alert(JSON.stringify(nextProps.feedbacks));
         }






    }

    titleChange(e){
      this.setState({
        [e.target.name]:e.target.value
      })
    }


    getForm(){
        //alert('im in');
        $("#formfeed").click();
    }

     onChangePage(pageOfItems) {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }


    fnGetmails(snapid){

        var snapid = snapid;

        fetch(Config.domainUrl+'personal/iseek-showmails', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    snapid:snapid
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
                if (responseJson.status != 0) {
                  //alert(JSON.stringify(responseJson));
                  if(responseJson.mails != ''){

                      Common.message('Mails',responseJson.mails);
                      this.setState({

                            mailsents : responseJson.mails
                        });
                  }
                  else{
                     Common.message('','No Results');
                  }
                }

         });
    }

     fnGetSaveAsPage(snapid){
         Common.reactLoader("show", "Please wait...");
        var snapid = snapid;
        let learnerID = Common.getUserData("id", true);
        fetch(Config.domainUrl+'personal/iseek-saveas', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    snapid:snapid,lr_id:learnerID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
                 Common.reactLoader("hide");
                 // alert(JSON.stringify(responseJson));


                // alert(responseJson.poll_answers.length-1);
                if( responseJson.poll_answers.length>0){
                    // let more_fields = '';
                    //let more_fields=[];
                   let length = responseJson.poll_answers.length-1;

                    //  alert(getdata);
                    // length.map(()=>{
                    //  more_fields.push({deleteoption: true});
                    // });

                    //alert(JSON.stringify(more_fields));
                    this.setState({
                        show : 'none',
                        hide : 'block',
                       // pollQuestions : more_fields,
                        length : length,
                        poll_title : responseJson.poll_title,
                        poll_answers : responseJson.poll_answers,
                        snap_poll_title :  responseJson.poll_title.snap_poll_title,
                    });
                    // alert(JSON.stringify(this.state.pollQuestions));
                }


         });




     }





     renameInput(type=""){
        setTimeout(function(){

            $('div[id^="Questionsedit"]').each(function(){


                let mainid=$(this).attr('id').split("_");

                if($('#Questionsedit_'+mainid[1]).find(".dummy_text_select")){
                    $('#Questionsedit_'+mainid[1]).find(".dummy_text_select").attr("name",'snap_poll_type['+mainid[1]+']').removeClass('dummy_text_select');

                }

                if($('#Questionsedit_'+mainid[1]).find(".dummy_text_parent")){
                    $('#Questionsedit_'+mainid[1]).find(".dummy_text_parent").attr("name",'snap_poll_question['+mainid[1]+']').removeClass('dummy_text_parent');

                }

                if($('#Questionsedit_'+mainid[1]).find(".dummy_text")){
                    $('#Questionsedit_'+mainid[1]).find(".dummy_text").attr("name",'snap_poll_answer['+mainid[1]+'][]').removeClass('dummy_text');
                    // $('#Questionsedit_'+mainid[1]).find('.answers_input').append('<input type="text" name="snap_poll_answer['+mainid[1]+'][]" class="txtbox"  />');
                }

                if($('#Questionsedit_'+mainid[1]).find(".addanswers")){
                    $('#Questionsedit_'+mainid[1]).find(".addanswers").attr("id",mainid[1]).removeClass('addanswers');

                }

            });
        },200);
    }

  submit(e){
      Common.reactLoader("show", "Please wait...");
    //let learnerID = Common.getUserData("id", true);
    let formData = new FormData();
      let snap_poll_add_new_edit_form=$('#snap_poll_add_new_edit_form').serializeArray();

      let details = [];
         snap_poll_add_new_edit_form.map((key,index)=>{
             details.push({[key.name]:key.value});
             formData.append(key.name,key.value);
         });

         //alert(JSON.stringify(details));
         fetch(Config.domainUrl +"personal", {
          method: "POST",
          //data: formData,

         headers: {
             'Accept': 'application/json',
             'Authorization':'Bearer ' +Common.getTokenData()
             //'Content-Type': 'application/json'
            },
          body: formData,
         }).then((response) => response.json()).then((responseJson) => {
           Common.reactLoader("hide");

             if (responseJson.status == 0) {
              Common.message(responseJson.message, responseJson.errors, "error");
            } else {
              Common.message("","Poll saved successfully. Assign this poll to your assessor(s).","success");
              $("#formfeed").click();
              $("#savedform").click();
            }
         });


  }




    getQuestype(e){
      //alert(JSON.stringify(e));
        // var div = this.refs.node.parentNode.parentNode.id;
        // //alert("#"+div+" #cmbPollQuestionType");
        // let id = div.split('_');
        // id= id[1];
        // id="cmbPollQuestionType"+id;
        var qtype = document.querySelectorAll('.qtype');

        var ansdiv = document.querySelectorAll('.ansdiv');
        // Set their ids
        for (var i = 0; i < qtype.length; i++)
            qtype[i].id = 'cmbPollQuestionType_' + i;

        for (var i = 0; i < ansdiv.length; i++)
            ansdiv[i].id = 'PollAnswertr_' + i;


        var id = e.target.id;
        var ansid = id.split('_');
        ansid = ansid[1];
        if($("#"+id).val()==2){
            $("#PollAnswertr_"+ansid).hide();
            // $("#PollAnswertr_"+ansid +' :input').attr('disabled',true);

        }
        else{
            $("#PollAnswertr_"+ansid).show();
            $("#PollAnswertr_"+ansid +' :input').removeAttr('disabled');

        }


    }






        render() {

            //alert(this.state.mailsents);
            // alert(JSON.stringify(this.state.pollQuestions));
            let learnerID = Common.getUserData("id", true);
            let date = new Date();
            let display_ansdiv ='';
            let dis = '';
            let polls = this.state.poll_answers.map((poll,k)=>{
              let ans_length = poll.answer.length-1;
              if(poll.type == '2'){
                display_ansdiv = 'none';
                dis = '';
              }
              else{
                display_ansdiv = 'block'
                dis = "disabled";
              }
              let answ = '';
              if(poll.answer != undefined){
                
                answ = poll.answer.map((ans,index)=>{
                if(ans.snap_poll_answer != ''){
                  return(
                      <div key={`chc_${index}`} id={'answersedit_'+index} className="child_inputs">
                        <input name={'snap_poll_answer['+k+'][]'} className="txtbox dummy_text"  type="text"  defaultValue={ans.snap_poll_answer}/>
                      </div>
                    )
                }
                });
              }
             if(poll.question!=""){

              return(
                      <div key={`pac_${k}`} id={'Questionsedit_'+k}>
                       <div className="graybox" id="question1">
                          <div className="fdback-left" >
                            <ul>
                                <li>
                                    <label>Question type</label>
                                    <div className="input-cntrl">
                                      <select name={'snap_poll_type['+k+']'}  className="qtype dummy_text_select" defaultValue={poll.type}  onChange={(e)=>this.getQuestype(e)} >
                                        <option value="1">Multiple choice question</option>
                                        <option value="2">Open ended question</option>
                                      </select>
                                    </div>
                                </li>
                                <li>
                                    <label>Question</label>
                                    <div className="input-cntrl">
                                      <input type="text" maxLength="255"  defaultValue={poll.question} name={'snap_poll_question['+k+']'} id="txtPollQuestion" className="snap_textbox dummy_text_parent" />
                                    </div>
                                </li>
                            </ul>
                          </div>
                          <div className="fdbk-right ansdiv" style={{display:display_ansdiv}} >
                            <ul id="Main_answer_div1">
                              <li id="answer_div11">
                                <label>Answer Choices</label>
                                <div className="input-cntrl addanswers" id={k}>
                                  <Addmore polls_sent={answ} selector="answersedit" limit={4} AddLabel="+ Add Choices" DeleteLabel="X" compType="child" editType="edit" startId={ans_length} refreshScroll={e=>this.renameInput(e)} parent="Questionsedit" subType="subtype">
                                      <input name={'snap_poll_answer['+k+'][]'} className="txtbox dummy_text"  type="text" disabled={dis}/>
                                  </Addmore>
                                </div>
                              </li>
                            </ul>
                          </div>
                       </div>
                      </div>
                )
             }
            })


            //const {feedbacks} = this.props;


             let rows = this.state.pageOfItems.map((feedback,i) => {

                return (

                           <tr key={`feedback_${i}`}>
                                <td >{feedback.sno}</td>
                                <td >{feedback.poll_title}</td>
                                <td >{feedback.createddate}</td>
                                <td ><a  onClick={()=>this.fnGetmails(feedback.snap_poll_id)} href="javascript:void(0)">{feedback.no_of_time_sent}</a></td>
                                <td ><img src={process.env.PUBLIC_URL+"/images/saveicon.png"} onClick={()=>this.fnGetSaveAsPage(feedback.snap_poll_id)}/></td>
                           </tr>
                        )
               });

               (rows.length == 0) ? rows = <tr align="center"><td colSpan="5">Currently you do not have any feedback form. You can create feedback forms by clicking
                        <a className="" href="javascript:void(0);" onClick={(e)=>this.getForm(e)}> here</a></td></tr> : rows = rows
            return (

                <div className="viewfdbktble" >
                    <div id="pageContent" style={{display:this.state.show}}>
                        <table  width="100%" border="0" className="myjourney-table tablesorter" cellPadding="0" cellSpacing="0" >
                            <thead>
                                <tr>
                                  <th>SNo<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} alt="" title=""/></th>
                                  <th>Form Title<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} alt="" title=""/></th>
                                  <th>Created date<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} alt="" title=""/></th>
                                  <th>No of time sent<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} alt="" title=""/></th>
                                  <th>Save as</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows}
                            </tbody>
                        </table>
                        <div className="pull-right">
                        <Pagination items={this.state.feedbacks} onChangePage={e=>this.onChangePage(e)} />
                        </div>
                    </div>
                    <div id="pagecontent1" style={{display:this.state.hide}}>
                        <div className="acc_content_poll">
                            <form id="snap_poll_add_new_edit_form" name="snap_poll_add_new_form" >
                                <div className="gradientbg gradientbg1">
                                  <label>Form Title</label>
                                    <input type="hidden"  name="created_date" value={date} format="Y-m-d"/>
                                    <input type="hidden"  name="lr_id" value={learnerID}/>
                                    <Titleinput title={this.state.snap_poll_title}/>
                                </div>
                                <div className="fdbk-content" id="Main_Question_div">
                                    <div>
                                    <Addmore polls_sent={polls} selector="Questionsedit" limit={6} AddLabel="+ Add Questions" DeleteLabel="X" compType="parent" editType="edit" startId={this.state.length} refreshScroll={e=>this.renameInput(e)} >
                                        <div className="graybox" id="question1">
                                            <div className="fdback-left" >
                                              <ul>
                                                  <li>
                                                      <label>Question type</label>
                                                      <div className="input-cntrl">
                                                        <select name="snap_poll_type[0]"  className="qtype dummy_text_select"  onChange={(e)=>this.getQuestype(e)} disabled>
                                                          <option value="1">Multiple choice question</option>
                                                          <option value="2">Open ended question</option>
                                                        </select>
                                                      </div>
                                                  </li>
                                                  <li>
                                                      <label>Question</label>
                                                      <div className="input-cntrl">
                                                        <input type="text" maxLength="255" name="snap_poll_question[0]" id="txtPollQuestion" className="snap_textbox dummy_text_parent" disabled/>
                                                      </div>
                                                  </li>
                                              </ul>
                                            </div>
                                            <div className="fdbk-right ansdiv" >
                                              <ul id="Main_answer_div1">
                                                <li id="answer_div11">
                                                  <label>Answer Choices</label>
                                                    <div className="input-cntrl addanswers" id="0">
                                                        <Addmore selector="answersedit" limit={4} AddLabel="+ Add Choices" DeleteLabel="X" compType="child" startId='0' editType="edit" refreshScroll={e=>this.renameInput(e)} parent="Questionsedit" >
                                                            <input name="snap_poll_answer[]" className="txtbox dummy_text"  type="text"  />
                                                        </Addmore>
                                                    </div>
                                                </li>
                                              </ul>
                                            </div>


                                          </div>
                                    </Addmore>
                                    </div>
                                  </div>
                                <div className="feedback-btns">
                                    <div className="fdbk-btn">

                                      <input type="button" name="btnSubmit" id="" value="Save & Send" alt="Save" title="Save" className="button-accept" onClick={e=>this.submit(e)}/>
                                      <input type="button" name="btnSubmit" id="" value="Save" alt="Save" title="Save" className="button-accept" onClick={e=>this.submit(e)}/>

                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>

                </div>


            );
        }
}

export default IseekView;



// WEBPACK FOOTER //
// ./src/personal_interactions/iseek/IseekView.js